import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const URL = getBaseUrl('/userExchanges/');

export async function getUserExchanges() {
    return await appRequest.doGetRequest(URL);
}

export async function createUserExchange(data) {
    return await appRequest.doPostRequest(URL, data);
}

export async function updateUserExchange(id, data) {
    return await appRequest.doPatchRequest(`${URL}${id}`, data);
}

export async function deleteUserExchange(id) {
    return await appRequest.doDeleteRequest(`${URL}${id}`);
}

export async function setPrimaryUserExchange(id, force = false) {
    const suffix = force ? '?force=true' : '';
    return await appRequest.doPostRequest(`${URL}${id}/setPrimary${suffix}`, {});
}

export async function testUserExchange(id, environment = 'production') {
    return await appRequest.doPostRequest(`${URL}${id}/test?environment=${environment}`, {});
}

// Bateria completa de API contra o testnet da corretora (place/status/cancel + fill).
export async function selfTestUserExchange(id, { fill = true } = {}) {
    const suffix = fill ? '' : '?fill=0';
    return await appRequest.doPostRequest(`${URL}${id}/self-test${suffix}`, {});
}

export async function getExchangeStatus() {
    return await appRequest.doGetRequest(`${URL}status`);
}
